"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.PhoneField = void 0;

var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/set"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _jsxRuntime = require("react/jsx-runtime");

var _UnderlinedTextField = require("@uifabric/portal-ux/lib/components/UnderlinedTextField");

var _react = require("@fluentui/react");

var React = _interopRequireWildcard(require("react"));

var _phoneCountryCodes = require("./phoneCountryCodes");

var phoneFieldStyles = require('./PhoneField.scoped.scss');

var PhoneField = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(PhoneField, _React$Component);

  var _super = (0, _createSuper2.default)(PhoneField);

  function PhoneField() {
    (0, _classCallCheck2.default)(this, PhoneField);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(PhoneField, [{
    key: "render",
    value: function render() {
      var _context;

      var _this$props = this.props,
          label = _this$props.label,
          phoneProps = _this$props.phoneProps;
      var countryRegionProps = this.props.countryRegionProps;

      if (!countryRegionProps.selectedKey) {
        countryRegionProps = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, countryRegionProps), {}, {
          selectedKey: _phoneCountryCodes.countryCodeOptions[0].key
        });
      }

      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Label, {
          children: label
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: phoneFieldStyles.gridContainer,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("select", {
              className: phoneFieldStyles.countryCodeSelect,
              disabled: this.props.countryRegionProps.disabled,
              onChange: this.props.countryRegionProps.onCountryCodeChange,
              "aria-label": this.props.countryRegionProps.ariaLabel,
              tabIndex: 0,
              defaultValue: countryRegionProps.selectedKey,
              children: (0, _map.default)(_context = localizeOptions(this.props.t, _phoneCountryCodes.countryCodeOptions)).call(_context, function (countryCodeOption) {
                return /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
                  value: countryCodeOption.data,
                  children: countryCodeOption.text
                }, countryCodeOption.key);
              })
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_UnderlinedTextField.UnderlinedTextField, (0, _objectSpread2.default)({}, phoneProps))
          })]
        })]
      });
    }
  }]);
  return PhoneField;
}(React.Component);

exports.PhoneField = PhoneField;
var localizeOptions = (0, _react.memoizeFunction)(function (t, options) {
  var itemsByKey = new _set.default();
  return (0, _map.default)(options).call(options, function (item) {
    var key = item.key.toString();

    if (itemsByKey.has(key)) {
      key += '-' + item.text;
      itemsByKey.add(key);
    } else {
      itemsByKey.add(key);
    }

    return {
      key: key,
      text: t(item.text, {
        ns: 'CountryCodes'
      }),
      data: item.key
    };
  });
});